/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {hasAuthority} from '../../../../../app/modules/utils/Permission'
import {UserModelLogin} from '../../../../../app/modules/auth/core/_models'
const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const userWithAuthorities = currentUser as UserModelLogin
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItemWithSub
        to=''
        title={intl.formatMessage({id: 'MENU.TASK'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/general/gen059.svg'
      >
        {hasAuthority('REPORT.STAFF.VIEW') && (
          <SidebarMenuItem
            to='/task/employee'
            title={intl.formatMessage({id: 'MENU.TASK.EMPLOYEE'})}
            hasBullet={true}
          />
        )}
        {hasAuthority('REPORT.VIEW') && (
          <SidebarMenuItem
            to='/task/others'
            title={intl.formatMessage({id: 'MENU.TASK.OTHER'})}
            hasBullet={true}
          />
        )}
      </SidebarMenuItemWithSub>
      {hasAuthority('TIMEKEEPING.VIEW') && (
        <SidebarMenuItem
          to='/timekeeping'
          icon='/media/icons/duotune/general/gen055.svg'
          title={intl.formatMessage({id: 'MENU.TIMEKEEPING'})}
          fontIcon='bi-layers'
        />
      )}
      {hasAuthority('PROGRESS.VIEW') && (
        <SidebarMenuItem
          to='/report'
          icon='/media/icons/duotune/files/fil004.svg'
          title={intl.formatMessage({id: 'MENU.REPORT'})}
          fontIcon='bi-layers'
        />
      )}
      <SidebarMenuItemWithSub
        to=''
        title={intl.formatMessage({id: 'MENU.CATEGORY'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        {hasAuthority('PROJECT.VIEW') && (
          <SidebarMenuItem
            to='/category/project'
            title={intl.formatMessage({id: 'MENU.CATEGORY.PROJECT'})}
            hasBullet={true}
          />
        )}
        {hasAuthority('TEAM.VIEW') && hasAuthority('MEMBER.VIEW') && (
          <SidebarMenuItem
            to='/category/personnel'
            title={intl.formatMessage({id: 'MENU.CATEGORY.PERSONNEL'})}
            hasBullet={true}
          />
        )}
      </SidebarMenuItemWithSub>
      {hasAuthority('USER.VIEW') && (
        <SidebarMenuItemWithSub
          to=''
          title={intl.formatMessage({id: 'MENU.ADMINISTRATION'})}
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/communication/com005.svg'
        >
          <SidebarMenuItem
            to='/administration/user'
            title={intl.formatMessage({id: 'MENU.ADMINISTRATION.USER'})}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}
    </>
  )
}

export {SidebarMenuMain}
